import { writable } from "svelte/store";

import * as testContents from "../configs/testItems.json";

const isChecked = {};

for (let testSection of testContents.default) {
  for (let testItem of testSection.items) {
    isChecked[testItem.ident] = false;
  }
}

const Store = writable(isChecked);

export default Store;

export const adsConfig = writable({
  footerBanner: false,
  interstitial: false,
});
